import axios from '~/utils/axios';

import { Account } from '~/types';

export const getPnlAccounts = () => {
  return axios.get<Account[]>(`tenant/accounts?page=1&perPage=9999`);
};
